import { createContext, useContext, useState, useCallback } from 'react';
import { api } from '../api';

// Auth state for the internal MIS. A successful login stores an opaque token and
// the user's display info in sessionStorage so a page refresh keeps the session,
// but it clears automatically when the tab/browser is closed.
const AuthContext = createContext(null);
const STORAGE_KEY = 'mis-auth';

function loadStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(loadStored);

  const login = useCallback(async (username, password) => {
    const { token, user } = await api.login(username, password);
    const next = { token, user };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setAuth(next);
    return next;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    setAuth(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user: auth?.user || null, token: auth?.token || null, isAuthed: !!auth?.token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
